export default __webpack_public_path__ + "static/media/IMG-20220413-WA0018@2x.fdf6ea35.png";